const STAT_CONTAINER_CLASS = 'nhs-n1-c-wrapper__2-columns nhs-n1-mq-wrapper__4-columns--medium';
const STAT_VALUE_CLASS = 'nhs-c-heading--black-1000-souvenir-heading-1-extra-large-light';
const STAT_KEY_CLASS = 'nhs-o-typography--sans-body-1-medium-medium';
const STAT_VALUE_ATTRIBUTE = 'data-state-search-market-overview-stats-value';
const STAT_KEY_ATTRIBUTE = 'data-state-search-market-overview-stats-key';

function createStatContainer() {
  const statContainer = document.createElement('div');
  statContainer.className = STAT_CONTAINER_CLASS;

  const valueContainer = document.createElement('p');
  valueContainer.className = STAT_VALUE_CLASS;
  valueContainer.setAttribute(STAT_VALUE_ATTRIBUTE, '');

  const keyContainer = document.createElement('p');
  keyContainer.className = STAT_KEY_CLASS;
  keyContainer.setAttribute(STAT_KEY_ATTRIBUTE, '');

  statContainer.appendChild(valueContainer);
  statContainer.appendChild(keyContainer);

  return statContainer;
}

function hydrateStatContainer(statContainer, key, value) {
  const valueElement = statContainer.querySelector(`[${STAT_VALUE_ATTRIBUTE}]`);
  const keyElement = statContainer.querySelector(`[${STAT_KEY_ATTRIBUTE}]`);

  if (valueElement) { valueElement.textContent = value; }
  if (keyElement) { keyElement.textContent = key; }
}

export default function updateMarketOverviewStats(statsElement, stats) {
  if (!statsElement) { return; }

  if (!stats) {
    statsElement.innerHTML = '';
    return;
  }

  Object.entries(stats).forEach(([key, value], index) => {
    let statContainer = statsElement.children[index];
    if (!statContainer) {
      statContainer = createStatContainer();
      statsElement.appendChild(statContainer);
    }
    hydrateStatContainer(statContainer, key, value);
  });
}
